import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../statusFail/statusFailSlice";

 const initialState = {
  locations: [],
  location: {},
  profileLocations: [],
  totalPages: 1,
  fetchLocationStatus: "idle",
  fetchStatus: false,
  createStatus: false,
  servicesLoading: false,
  packagesLoading:false,
  diagnosticLoading: false,
  pharmacyLoading: false,
  servicesError: null,
  packagesError:null,
  diagnosticError: null,
  pharmacyError: null,
  editForm: false,
  error: null,
  deletError: null,
};

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;
// const PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL 

export const fetchLocations = createAsyncThunk(
  "locations/fetchLocations",
  async ({ currentPage, itemsPerPage, sortBy, order }, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/locations`, {
        params: {
          page: currentPage,
          limit: itemsPerPage,
          sortBy,
          order,
        },

        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
          tenantId: Cookies.get("TenantId"),
        },
      });
     
      return response.data.data;
    } catch (error) {
        if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
         const route = "/status-failed"
         await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
       }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const fetchLocationById = createAsyncThunk(
  "locations/fetchLocationById",
  async ({ locationsId }, { rejectWithValue, dispatch }) => {
    try {
      const idResponses = await Promise.all(
        locationsId.map(async (id) => {
          try {
            const res = await axios.get(`${ADMIN_URL}/locations/${id}`, {
              headers: {
                Authorization: `Bearer ${Cookies.get("Token")}`,
                tenantId: Cookies.get("TenantId"),
              },
            });
           
            return res.data.data;
          } catch (err) {
            console.error(`Failed to fetch details for ID: ${id}`, err);
            return null;
          }
        })
      );
      return idResponses;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
             const route = "/status-failed"
             await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
           }
       return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
     }
  }
);

export const createLocation = createAsyncThunk(
  "locations/createLocation",
  async (newLocation, { rejectWithValue,dispatch }) => {
 
    try {
      const response = await axios.post(
        `${ADMIN_URL}/locations`,
        newLocation,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
      return response.data.data;
    } catch (error) {
      const errorMessage = error.response?.data?.error?.message || error.message || "Failed to create location";
      if(error.response?.data?.errorCode== "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(errorMessage);
    }
  }
);

export const getLocation = createAsyncThunk(
  "locations/getLocation",
  async (id, { rejectWithValue,dispatch }) => {
    try {
      const response = await axios.get(`${ADMIN_URL}/locations/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message || "Something went wrong");
    }
  }
);

export const updateLocation = createAsyncThunk(
  "locations/updateLocation",
  async ({ id, newLocation }, { rejectWithValue,dispatch }) => {
 
 try {
      const response = await axios.patch(
        `${ADMIN_URL}/locations/${id}`,
        newLocation,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
    
      return {  location: response.data.data, id ,newLocation};
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue({error:error.response.data?.error?.message || "Something went wrong",newLocation});
    }
  }
);

export const deleteLocation = createAsyncThunk(
  "locations/deleteLocation",
  async (id, { rejectWithValue,dispatch }) => {
    try {
      // eslint-disable-next-line
      const response = await axios.delete(`${ADMIN_URL}/locations/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });

      return id;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response.data?.error?.message);
    }
  }
);


export const updateNestedItem = createAsyncThunk(
  "locations/updateNestedItem",
  async ({ locationId, arrayName, itemId, updateData }, { rejectWithValue,dispatch }) => {
    console.log(locationId,arrayName,itemId,updateData,"updateNestedItem");
    try {
      // eslint-disable-next-line
      const response = await axios.put(`${ADMIN_URL}/locations/${locationId}/update-item/${arrayName}/${itemId}`,
        updateData,
        {
          headers: {
            Authorization: `Bearer ${Cookies.get("Token")}`,
          },
        }
      );
      return { locationId, arrayName, itemId, updatedItem: updateData};
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue({error:error.response?.data?.error?.message || "Failed to update item",arrayName});
    }
  }
);

  const locationsSlice = createSlice({
    name: "locations",
    initialState,
    reducers: {refreshlocations: (state, action) => ({...state,locations:action.payload}),
    toggleEditForm: (state) => {
      state.editForm = !state.editForm; 
      if (!state.editForm) {
        state.selectedService = null;
      }
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    clearError:(state,action)=>{
      const arrayName = action.payload
      state[`${arrayName}Error`] = null;
    },
  
  },
    
    extraReducers: (builder) => {
      builder
        .addCase(fetchLocations.pending, (state) => {
          state.fetchStatus = true;
          state.error =  null
        })
        .addCase(fetchLocations.fulfilled, (state, action) => {
          state.fetchStatus = false;
          state.locations = action.payload.data;
          state.totalPages = action.payload.totalPages;
        })
        .addCase(fetchLocations.rejected, (state, action) => {
          state.fetchStatus = false;
          state.error = action.payload;
        })
           .addCase(fetchLocationById.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(fetchLocationById.fulfilled, (state, action) => {
        state.fetchStatus = "succeeded";
        state.profileLocations = action.payload;
      })
      .addCase(fetchLocationById.rejected, (state, action) => {
        state.fetchStatus = "failed";
        state.error = action.payload;
      })
        .addCase(createLocation.pending, (state) => {
          state.createStatus = true;
        })
        .addCase(createLocation.fulfilled, (state, action) => {
          state.createStatus =false;
          state.locations.push(action.payload);
          state.error = null;
        })
        .addCase(createLocation.rejected, (state, action) => {
          state.createStatus = false;
          state.error = action.payload;
        })
        .addCase(getLocation.pending, (state) => {
          state.fetchLocationStatus = "loading";
        })
        .addCase(getLocation.fulfilled, (state, action) => {
          state.fetchLocationStatus = "succeeded";
          state.location = action.payload;
          state.error = null;
        })
        .addCase(getLocation.rejected, (state, action) => {
          state.fetchLocationStatus = "failed";
          state.location={}
          state.error = action.payload;
        })
        .addCase(updateLocation.pending, (state,action) => {
          // state.createStatus = true;
          const {newLocation} = action.meta.arg;
          const arrayName =  Object.keys(newLocation)[0];
          state[`${arrayName}Loading`] = true;
          state[`${arrayName}Error`] = null;

        })
        .addCase(updateLocation.fulfilled, (state, action) => {
          const {newLocation} = action.payload;
          const arrayName =  Object.keys(newLocation)[0];
          state[`${arrayName}Loading`] = false;
        })
        .addCase(updateLocation.rejected, (state, action) => {
          const {newLocation,error} = action.payload;
          const arrayName =  Object.keys(newLocation)[0];
          state[`${arrayName}Loading`] = false;
          state[`${arrayName}Error`] = error;
        })
        .addCase(deleteLocation.fulfilled, (state, action) => {
          state.fetchStatus = "succeeded";
          const filteredLocations = state.locations.filter(
            (elm) => elm._id !== action.payload
          );
          state.locations = filteredLocations
          state.deletError = null;
        })
        .addCase(deleteLocation.pending, (state) => {
          state.fetchStatus = "loading";
          state.deletError = null;
        })
        .addCase(deleteLocation.rejected, (state, action) => {
          state.fetchStatus = "failed";
          state.deletError = action.payload;
        })
        .addCase(updateNestedItem.pending, (state,action) => {
          const {  arrayName } = action.meta.arg;
          state[`${arrayName}Loading`] = true;
          state[`${arrayName}Error`] = null;
        })
        .addCase(updateNestedItem.fulfilled, (state, action) => {
          const { locationId, arrayName, itemId, updatedItem } = action.payload;
          state[`${arrayName}Loading`] = false;
          state.locations = state.locations.map((location) => {
            if (location._id === locationId) {
              return {
                ...location,
                [arrayName]: location[arrayName].map((item) =>
                  item._id === itemId ? {...item,...updatedItem,} : item
                ),
              };
            }
            return location;
          });
  
        })
        .addCase(updateNestedItem.rejected, (state, action) => {
          const { arrayName,error} = action;
          state[`${arrayName}Loading`] = false;
          state[`${arrayName}Error`]= error;
        });
    },
  });

  export const { refreshlocations,toggleEditForm,setSelectedService,clearError} = locationsSlice.actions;

  export default locationsSlice.reducer;
